import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import Web3 from 'web3';

var StandardContract =
/**
 * Constructor ArbitrableTransaction.
 * @param {object} web3Provider instance.
 * @param {string} ipfsGateway IPFS gateway URI.
 */
function StandardContract(web3Provider, ipfsGateway) {
  var _this = this;

  _classCallCheck(this, StandardContract);

  this.setProvider = function (newProvider) {
    _this.web3.setProvider(newProvider);
  };

  this.setIpfsGateway = function (newGateway) {
    _this.ipfsGateway = newGateway;
  };

  this.web3 = new Web3(web3Provider);
  this.ipfsGateway = ipfsGateway;
};

export default StandardContract;